/**
 * mcycle homepage header banner module
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/8
 */
import './banner.css';
import React from 'react';
import { connect } from 'react-redux';
import Image from '../../../lib/image';

// TODO
const Base = () => (
  <img src="//openfile.meizu.com/group1/M00/00/CE/Cix_s1hKIMWAE6ofAAYZmFZluCM676.png" alt="banner" />
);

const Banner = ({ pageInfo }) => (
  <div className="mcycle-home-slider">
    <Image src={ pageInfo.frontConfig.bannerImage } alt='banner' base={<Base />}  />
  </div>
);


export default connect(
  state => ({
    pageInfo: state.home.pageInfo
  })
)(Banner);



// WEBPACK FOOTER //
// ./src/components/home/header/banner/banner.js